import { ContractInfoDto } from '@sr/dto';
import { LinkToContract } from 'shared/ui/links/link-to-contract';

export const InvoiceContract = ({ contract }: { contract: ContractInfoDto }) => {

  return (
    <LinkToContract contract={contract} />
  );
};